(function () {
	'use strict';

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	var classCallCheck = _classCallCheck;

	var _classCallCheck$1 = /*@__PURE__*/getDefaultExportFromCjs(classCallCheck);

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	var createClass = _createClass;

	var _createClass$1 = /*@__PURE__*/getDefaultExportFromCjs(createClass);

	function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	var ShopifyQuickSearch = /*#__PURE__*/function () {
	  function ShopifyQuickSearch() {
	    _classCallCheck$1(this, ShopifyQuickSearch);

	    this.pageUrl = window.location.href;
	    this.lastQueryResults = [];
	    this.lastSearchResults = '';
	    this.root = document.querySelector('[data-search]');
	    if (!this.root) return;
	    this.form = this.root.querySelector('[data-search-form]');
	    this.input = this.form.querySelector('input[type="search"]');
	    this.results = this.root.querySelector('[data-search-results]');
	    this.suggestions = this.root.querySelector('[data-search-suggestions]');
	    this.closeButton = this.form.querySelector('[data-header-search-close]');
	    this.popularSuggestions = this.form.querySelectorAll('[data-group="suggestions"] a');
	    this.initEvents();
	  }

	  _createClass$1(ShopifyQuickSearch, [{
	    key: "initEvents",
	    value: function initEvents() {
	      var _this = this;

	      this.popularSuggestions.forEach(function (el) {
	        el.addEventListener('click', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	          _this.input.value = el.innerText;

	          _this.input.dispatchEvent(new Event('input', {
	            bubbles: true
	          }));
	        });
	      });
	      this.closeButton.addEventListener('click', function () {
	        _this.resetResults();
	      });
	      this.input.addEventListener('input', this.debounce(function (event) {
	        return _this.onChange(event);
	      }, 250).bind(this));
	      this.form.addEventListener('submit', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	      document.querySelector('[data-header-search-toggle]').addEventListener('click', function (e) {
	        _this.input.focus();
	      });
	    }
	  }, {
	    key: "hashCode",
	    value: function hashCode(s) {
	      return s.split('').reduce(function (a, b) {
	        a = (a << 5) - a + b.charCodeAt(0);
	        return a & a;
	      }, 0);
	    }
	  }, {
	    key: "debounce",
	    value: function debounce(fn, wait) {
	      var _this2 = this;

	      var t;
	      return function () {
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }

	        clearTimeout(t);
	        t = setTimeout(function () {
	          return fn.apply(_this2, args);
	        }, wait);
	      };
	    }
	  }, {
	    key: "updateUrlHistory",
	    value: function updateUrlHistory(searchTerm) {
	      if (window.history.pushState) {
	        var url = new URL(window.location.origin + '/search');
	        url.searchParams.set('q', searchTerm);
	        window.history.pushState({
	          path: url.href
	        }, '', url.href);
	      }
	    }
	  }, {
	    key: "resetUrlHistory",
	    value: function resetUrlHistory() {
	      if (window.history.pushState) {
	        var url = new URL(this.pageUrl);
	        window.history.pushState({
	          path: url.href
	        }, '', url.href);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(e) {
	      e.preventDefault();
	      var searchTerm = this.input.value.trim();

	      if (!searchTerm.length) {
	        this.resetResults();
	        return false;
	      } // only get query results when user is typing


	      if (e.inputType) {
	        this.getQueryResults(e);
	      }

	      this.getSearchResults(searchTerm);
	      return false;
	    }
	  }, {
	    key: "getQueryResults",
	    value: function getQueryResults(event) {
	      var querySuggestions = this.form.querySelector('#suggestions');
	      if (event.target.value.length < 2) return;
	      var searchTerm = encodeURIComponent(event.target.value.trim());
	      var hash = this.hashCode(searchTerm);
	      if (this.lastQueryResults === hash) return;
	      this.lastQueryResults = hash;
	      fetch(window.Shopify.routes.root + "search/suggest.json?resources[type]=query&q=".concat(searchTerm, "&resources[limit]=5")).then(function (response) {
	        querySuggestions.replaceChildren();

	        if (!response.ok) {
	          throw new Error(response.status);
	        }

	        return response.json();
	      }).then(function (data) {
	        // for data.resource.results.queries
	        var _iterator = _createForOfIteratorHelper(data.resources.results.queries),
	            _step;

	        try {
	          for (_iterator.s(); !(_step = _iterator.n()).done;) {
	            var query = _step.value;
	            var suggestion = document.createElement('option');
	            suggestion.setAttribute('value', query.text.replace(/(^\w{1})|(\s+\w{1})/g, function (letter) {
	              return letter.toUpperCase();
	            }));
	            querySuggestions.appendChild(suggestion);
	          }
	        } catch (err) {
	          _iterator.e(err);
	        } finally {
	          _iterator.f();
	        }
	      })["catch"](function (error) {
	        console.error('Error:', error);
	      });
	    }
	  }, {
	    key: "getSearchResults",
	    value: function getSearchResults(searchTerm) {
	      var _this3 = this;

	      searchTerm = encodeURIComponent(searchTerm);
	      var hash = this.hashCode(searchTerm);
	      if (this.lastSearchResults === hash) return;
	      this.lastSearchResults = hash;
	      this.root.classList.add('loading');
	      fetch(window.Shopify.routes.root + "search/suggest?q=".concat(searchTerm, "&resources[type]=product,query,article,collection,page&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search-results&resources[options][fields]=title,product_type,variants.title,body,variants.sku")).then(function (response) {
	        if (!response.ok) {
	          _this3.loaderRemove();

	          _this3.resultsDisplay(false);

	          throw new Error(response.status);
	        }

	        return response.text();
	      }).then(function (text) {
	        var resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-results').innerHTML;

	        if (!resultsMarkup.trim()) {
	          _this3.resultsDisplay(false);

	          return;
	        }

	        _this3.results.innerHTML = text;

	        _this3.loaderRemove();

	        _this3.resultsDisplay(true);

	        _this3.updateUrlHistory(searchTerm);

	        if (window.addToBag) {
	          window.addToBag(_this3.results);
	        }
	      })["catch"](function (error) {
	        _this3.loaderRemove();

	        console.error('Error:', error);
	      });
	    }
	  }, {
	    key: "loaderRemove",
	    value: function loaderRemove() {
	      var _this4 = this;

	      setTimeout(function () {
	        _this4.root.classList.remove('loading');
	      }, 100);
	    }
	  }, {
	    key: "resultsDisplay",
	    value: function resultsDisplay(bool) {
	      this.results.style.display = bool ? 'block' : 'none';
	      this.suggestions.style.display = bool ? 'none' : 'block';
	    }
	  }, {
	    key: "resetResults",
	    value: function resetResults() {
	      this.input.value = '';
	      this.results.innerHTML = '';
	      this.root.classList.remove('loading');
	      this.resultsDisplay(false);
	      this.form.querySelector('#suggestions').replaceChildren();
	      this.resetUrlHistory();
	    }
	  }]);

	  return ShopifyQuickSearch;
	}();

	new ShopifyQuickSearch();

})();
